import React, { FC } from 'react'
import EventBusy from '@mui/icons-material/EventBusy'
import { Calendar, Event } from './types'
import VendorDetails from './components/VendorDetails'
import PointOfContact from './components/PointOfContact'

interface CanceledProps {
  calendar: Calendar
  event: Event
}

const Canceled: FC<CanceledProps> = ({ calendar, event }) => {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:mx-4">
      <div className="tw:p-6 tw:pt-8 tw:flex tw:flex-col tw:items-center tw:bg-white tw:rounded-5xl tw:border tw:border-neutrals-300">
        <div className="tw:bg-red-100 tw:rounded-full tw:p-6">
          <EventBusy className="tw:text-red-600 tw:!size-12" />
        </div>
        <h2 className="tw:text-lg tw:font-bold tw:mt-6">{'Site visit canceled'}</h2>
        <p className="tw:text-tertiary-black tw:mt-1 tw:text-center">
          {'This site visit was canceled. If you believe this is an error, reach out to '}
          <a href={`mailto:${calendar.advisor.email}`} className="tw:hover:underline">
            {calendar.advisor.email}
          </a>
        </p>
      </div>
      <VendorDetails event={event} />
      <PointOfContact calendar={calendar} />
    </div>
  )
}

export default Canceled
